import { urls } from 'constants/urls';
import { getFeatureFlags } from 'utils/featureFlags';
import { isWindowAvailable } from './browser';

export const loginPagePath = () => {
  const { identity_enableOAuth2Web: OAuth2Enabled } = getFeatureFlags();
  const url = OAuth2Enabled ? urls.loginOAuth2 : urls.login;

  return isWindowAvailable && OAuth2Enabled
    ? `${url}?redirect=${encodeURIComponent(window.location.pathname)}`
    : url;
};
